export const COUNTRY_CODE_CURRENCIES = {
    AUT: 'EUR',
    BEL: 'EUR',
    HRV: 'EUR',
    CYP: 'EUR',
    DNK: 'EUR',
    EST: 'EUR',
    FIN: 'EUR',
    FRA: 'EUR',
    DEU: 'EUR',
    GRC: 'EUR',
    IRL: 'EUR',
    ITA: 'EUR',
    LVA: 'EUR',
    LTU: 'EUR',
    LUX: 'EUR',
    MLT: 'EUR',
    NLD: 'EUR',
    PRT: 'EUR',
    ROU: 'RON',
    SVK: 'EUR',
    SVN: 'EUR',
    ESP: 'EUR',
    BGR: 'BGN',
    CZE: 'CZK',
    HUN: 'HUF',
    NOR: 'NOK',
    SWE: 'SEK',
    POL: 'PLN',
    GBR: 'GBP',
    LIE: 'CHF',
};
//# sourceMappingURL=countryCodeCurrencies.js.map